import React from "react";
import { ContextMenu, ContextMenuItem } from "src/components/ContextMenu";
import { useDraftsContextMenu } from "./useDraftsContextMenu";
import { PropsType } from "./types";

export const DraftsContextMenu: React.FC<PropsType> = (props) => {
  const { handleOnClickView, handleOnClickDelete } =
    useDraftsContextMenu(props);
  return (
    <ContextMenu consumerAnchorEl={props.consumerAnchorEl}>
      <ContextMenuItem onHandleClick={handleOnClickView}>View</ContextMenuItem>
      <ContextMenuItem onHandleClick={handleOnClickDelete}>
        Delete...
      </ContextMenuItem>
    </ContextMenu>
  );
};
